import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "document-list__cell-player"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_link = _resolveComponent("el-link")!
  const _component_TagListCollapsible = _resolveComponent("TagListCollapsible")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _ctx.paginatedDocumentList,
      class: "document-list__table",
      border: "",
      size: "small",
      "tooltip-effect": "light"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentColumnsList, (column) => {
          return (_openBlock(), _createBlock(_component_el_table_column, _mergeProps({
            key: column.prop
          }, { ref_for: true }, column), {
            default: _withCtx(({ row }) => [
              (column.label === _ctx.documentColumnLabel[_ctx.DocumentColumnProperties.PLAYER])
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_el_link, {
                      type: "primary",
                      underline: "always",
                      class: "document-list__cell-player-link",
                      onClick: ($event: any) => (_ctx.openPlayerProfile(
                row[_ctx.DocumentColumnProperties.PLAYER_ID],
                row[_ctx.DocumentColumnProperties.WHITELABEL_SLUG]
              ))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row[_ctx.DocumentColumnProperties.PLAYER_EMAIL]), 1 /* TEXT */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                    _createVNode(_component_TagListCollapsible, {
                      "tag-list": row[_ctx.DocumentColumnProperties.PLAYER_TAG_LIST] ?? [],
                      "display-limit-count": 2,
                      "get-tag-text-color": _ctx.getTextColorByBackground
                    }, null, 8 /* PROPS */, ["tag-list", "get-tag-text-color"])
                  ]))
                : _createCommentVNode("v-if", true),
              (column.label === _ctx.documentColumnLabel[_ctx.DocumentColumnProperties.ACTIONS])
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.isUpdateTransactionModerationInfoFlowAllowed)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (row[_ctx.DocumentColumnProperties.DOCUMENT_MODERATION_ACTION])
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                type: row[_ctx.DocumentColumnProperties.ACTION_TYPE],
                                size: "small",
                                plain: "",
                                onClick: ($event: any) => (_ctx.updateDocumentModeration(row))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(row[_ctx.DocumentColumnProperties.ACTION_LABEL]), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["type", "onClick"]))
                            : _createCommentVNode("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ]),
            _: 2 /* DYNAMIC */
          }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["data"])), [
      [_directive_loading, _ctx.isDocumentListLoading]
    ]),
    _createVNode(_component_el_pagination, {
      "page-size": _ctx.limit,
      "onUpdate:pageSize": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.limit) = $event)),
      "current-page": _ctx.currentPage,
      "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentPage) = $event)),
      class: "document-list__pagination",
      size: "small",
      "page-sizes": _ctx.paginationProperties.pageSizes,
      layout: _ctx.paginationProperties.layout,
      total: _ctx.documentListCount,
      "popper-class": "document-list__pagination-dropdown"
    }, null, 8 /* PROPS */, ["page-size", "current-page", "page-sizes", "layout", "total"])
  ], 64 /* STABLE_FRAGMENT */))
}